import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {
    showSideMenuUsers,
    showSideMenuBlocks,
    showSideMenuPages,
    showSideMenuConfiguration,
} from '../components/permissions/permissions';
import {requireAuthentication} from '../containers/auth/require_auth';
import SignIn from '../containers/auth/sign_in';
import SignOut from '../containers/auth/sign_out';
import Dashboard from '../containers/dashboard/dashboard';
import UsersSettings from '../containers/users/index';
import UserEditTabs from '../containers/users/UserEditTabs';
import Configuration from '../containers/configuration/index';
import BlocksSettings from '../containers/blocks/index';
import BlockCreate from '../containers/blocks/BlockCreate';
import BlockEditTabs from '../containers/blocks/BlockEditTabs';
import BlockViewContents from '../containers/blocks/BlockView';
import TranslationEditTabs from '../containers/blocks/translations/TranslationEditTabs';
import TranslationViewContents from '../containers/blocks/translations/TranslationView';
import PageBuilder from '../containers/builder/builder';
import PagesSettings from '../containers/pages/index';
import LabelsSettings from '../containers/labels/index';
import LabelCreate from '../containers/labels/LabelCreate';
import LabelEditTabs from '../containers/labels/LabelEditTabs';
import LabelAddTranslation from '../containers/labels/translations/LabelTranslationCreate';
import LabelEditViewTranslation from '../containers/labels/translations/LabelEditViewTranslation';
import MenuManager from '../containers/menus/index';
import MenuEdit from '../containers/menus/MenuEdit';
import MenuView from '../containers/menus/MenuView';
import StaffSettings from '../containers/staff';
import StaffCreateMember from '../containers/staff/StaffCreate';
import StaffEditTabs from '../containers/staff/StaffEditTabs';
import StaffAddTranslation from '../containers/staff/translations/StaffTranslationCreate';
import StaffEditViewTranslation from '../containers/staff/translations/StaffEditViewTranslation';
import TemplateBuilder from '../containers/templates/builder/TemplateBuilder';
import TemplateSettings from '../containers/templates/index';
import RedirectsSettings from '../containers/redirects/index';
import RedirectCreate from '../containers/redirects/RedirectCreate';
import RedirectsBulk from '../containers/redirects/RedirectsBulkAdd';
import RedirectEdit from '../containers/redirects/RedirectEdit';
import TagsSettings from '../containers/tags/index';
import TagCreate from '../containers/tags/TagCreate';
import TagEditTabs from '../containers/tags/TagEditTabs';
import FaqsSettings from '../containers/faqs/index';
import FaqsCreate from '../containers/faqs/FaqsCreate';
import FaqsEditTabs from '../containers/faqs/FaqsEditTabs';
import FaqAddTranslation from '../containers/faqs/translations/FaqTranslationCreate';
import FaqEditViewTranslation from '../containers/faqs/translations/FaqEditViewTranslation';
import MyAccountEdit from '../containers/myaccount/MyAccountEdit';
import WebinarsSettings from '../containers/webinars/index';
import WebinarCreate from '../containers/webinars/WebinarCreate';
import WebinarEdit from '../containers/webinars/WebinarEdit';

export default () => (
    <Switch>
        <Route exact path="/" component={requireAuthentication(Dashboard)} />

        <Route exact path="/login" component={SignIn} />
        <Route exact path="/logout" component={SignOut} />

        <Route
            exact
            path="/users"
            component={requireAuthentication(
                showSideMenuUsers(UsersSettings, Dashboard)
            )}
        />
        <Route
            exact
            path="/users/:id"
            component={requireAuthentication(showSideMenuUsers(UserEditTabs))}
        />
        <Route
            exact
            path="/users/:id/permissions"
            component={requireAuthentication(showSideMenuUsers(UserEditTabs))}
        />
        <Route
            exact
            path="/roles"
            component={requireAuthentication(showSideMenuUsers(UsersSettings))}
        />
        <Route
            exact
            path="/configure"
            component={requireAuthentication(
                showSideMenuConfiguration(Configuration)
            )}
        />
        <Route
            exact
            path="/configuration/reviews-allocation"
            component={requireAuthentication(
                showSideMenuConfiguration(Configuration)
            )}
        />
        <Route
            exact
            path="/blocks"
            component={requireAuthentication(
                showSideMenuBlocks(BlocksSettings)
            )}
        />
        <Route
            exact
            path="/blocks/new"
            redirect="/blocks"
            component={requireAuthentication(showSideMenuBlocks(BlockCreate))}
        />
        <Route
            exact
            path="/blocks/:id"
            component={requireAuthentication(showSideMenuBlocks(BlockEditTabs))}
        />
        <Route
            exact
            path="/blocks/:id/translations"
            component={requireAuthentication(showSideMenuBlocks(BlockEditTabs))}
        />
        <Route
            exact
            path="/blocks/:id/revisions"
            component={requireAuthentication(showSideMenuBlocks(BlockEditTabs))}
        />
        <Route
            exact
            path="/blocks/:blockId/translations/:siteId"
            component={requireAuthentication(
                showSideMenuBlocks(TranslationEditTabs)
            )}
        />
        <Route
            exact
            path="/blocks/:blockId/translations/:siteId/revisions"
            component={requireAuthentication(
                showSideMenuBlocks(TranslationEditTabs)
            )}
        />
        <Route
            exact
            path="/blocks/:blockId/translations/:siteId/view"
            component={requireAuthentication(
                showSideMenuBlocks(TranslationViewContents)
            )}
        />
        <Route
            exact
            path="/blocks/:blockId/view"
            component={requireAuthentication(
                showSideMenuBlocks(BlockViewContents)
            )}
        />
        <Route
            exact
            path="/pages"
            component={requireAuthentication(showSideMenuPages(PagesSettings))}
        />
        <Route
            exact
            path="/pages/:id"
            component={requireAuthentication(showSideMenuPages(PageBuilder))}
        />
        <Route
            exact
            path="/pages/:id/sort"
            component={requireAuthentication(showSideMenuPages(PageBuilder))}
        />
        <Route
            exact
            path="/pages/:id/versions"
            component={requireAuthentication(showSideMenuPages(PageBuilder))}
        />
        <Route
            exact
            path="/templates"
            component={requireAuthentication(
                showSideMenuPages(TemplateSettings)
            )}
        />
        <Route
            exact
            path="/template/:id"
            component={requireAuthentication(
                showSideMenuPages(TemplateBuilder)
            )}
        />
        <Route
            exact
            path="/template/:id/history"
            component={requireAuthentication(
                showSideMenuPages(TemplateBuilder)
            )}
        />
        <Route
            exact
            path="/staff"
            component={requireAuthentication(StaffSettings)}
        />
        <Route
            exact
            path="/staff/new"
            redirect="/staff"
            component={requireAuthentication(StaffCreateMember)}
        />
        <Route
            exact
            path="/staff/:id"
            component={requireAuthentication(showSideMenuBlocks(StaffEditTabs))}
        />
        <Route
            exact
            path="/staff/:id/translations"
            component={requireAuthentication(StaffEditTabs)}
        />
        <Route
            exact
            path="/staff/:staffId/translations/:siteId/add"
            component={requireAuthentication(StaffAddTranslation)}
        />
        <Route
            exact
            path="/staff/:staffId/translations/:translationId/edit"
            component={requireAuthentication(StaffEditViewTranslation)}
        />
        <Route
            exact
            path="/staff/:staffId/translations/:translationId/view"
            component={requireAuthentication(StaffEditViewTranslation)}
        />
        <Route
            exact
            path="/dashboard"
            component={requireAuthentication(Dashboard)}
        />
        <Route
            exact
            path="/menus"
            component={requireAuthentication(MenuManager)}
        />
        <Route
            exact
            path="/menus/:id/:menuSiteId"
            component={requireAuthentication(MenuEdit)}
        />
        <Route
            exact
            path="/menus/:id/:menuSiteId/view"
            component={requireAuthentication(MenuView)}
        />
        <Route
            exact
            path="/labels"
            component={requireAuthentication(LabelsSettings)}
        />
        <Route
            exact
            path="/labels/new"
            component={requireAuthentication(LabelCreate)}
        />
        <Route
            exact
            path="/labels/:id"
            component={requireAuthentication(LabelEditTabs)}
        />
        <Route
            exact
            path="/labels/:id/translations"
            component={requireAuthentication(LabelEditTabs)}
        />
        <Route
            exact
            path="/labels/:labelId/translations/:siteId"
            component={requireAuthentication(LabelAddTranslation)}
        />
        <Route
            exact
            path="/labels/:labelId/translations/:translationId/edit"
            component={requireAuthentication(LabelEditViewTranslation)}
        />
        <Route
            exact
            path="/labels/:labelId/translations/:translationId/view"
            component={requireAuthentication(LabelEditViewTranslation)}
        />
        <Route
            exact
            path="/redirects"
            component={requireAuthentication(
                showSideMenuBlocks(RedirectsSettings)
            )}
        />
        <Route
            exact
            path="/redirects/new"
            redirect="/redirects"
            component={requireAuthentication(
                showSideMenuBlocks(RedirectCreate)
            )}
        />
        <Route
            exact
            path="/redirects/bulk"
            redirect="/redirects"
            component={requireAuthentication(showSideMenuBlocks(RedirectsBulk))}
        />
        <Route
            exact
            path="/redirects/:id"
            redirect="/redirects"
            component={requireAuthentication(showSideMenuBlocks(RedirectEdit))}
        />
        <Route
            exact
            path="/tags"
            component={requireAuthentication(showSideMenuBlocks(TagsSettings))}
        />
        <Route
            exact
            path="/tags/new"
            redirect="/tags"
            component={requireAuthentication(showSideMenuBlocks(TagCreate))}
        />
        <Route
            exact
            path="/tags/:id"
            redirect="/tags"
            component={requireAuthentication(showSideMenuBlocks(TagEditTabs))}
        />
        <Route
            exact
            path="/tags/:id/translations"
            component={requireAuthentication(TagEditTabs)}
        />
        <Route
            exact
            path="/faqs"
            component={requireAuthentication(showSideMenuBlocks(FaqsSettings))}
        />
        <Route
            exact
            path="/faqs/new"
            redirect="/faqs"
            component={requireAuthentication(showSideMenuBlocks(FaqsCreate))}
        />
        <Route
            exact
            path="/faqs/:id"
            redirect="/faqs"
            component={requireAuthentication(showSideMenuBlocks(FaqsEditTabs))}
        />
        <Route
            exact
            path="/faqs/:id/translations"
            component={requireAuthentication(FaqsEditTabs)}
        />
        <Route
            exact
            path="/faqs/:faqId/translations/:siteId"
            component={requireAuthentication(FaqAddTranslation)}
        />
        <Route
            exact
            path="/faqs/:faqId/translations/:translationId/edit"
            component={requireAuthentication(FaqEditViewTranslation)}
        />
        <Route
            exact
            path="/faqs/:faqId/translations/:translationId/view"
            component={requireAuthentication(FaqEditViewTranslation)}
        />
        <Route
            exact
            path="/myaccount/:userId"
            component={requireAuthentication(MyAccountEdit)}
        />
        <Route
            exact
            path="/webinars"
            component={requireAuthentication(WebinarsSettings)}
        />
        <Route
            exact
            path="/webinars/new"
            redirect="/webinars"
            component={requireAuthentication(showSideMenuBlocks(WebinarCreate))}
        />
        <Route
            exact
            path="/webinars/:id"
            redirect="/webinars"
            component={requireAuthentication(showSideMenuBlocks(WebinarEdit))}
        />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/routes/index.js